import { render, staticRenderFns } from "./YouTubeChannelDetail.vue?vue&type=template&id=a4cdcf7c&scoped=true"
import script from "./YouTubeChannelDetail.vue?vue&type=script&lang=js"
export * from "./YouTubeChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./YouTubeChannelDetail.vue?vue&type=style&index=0&id=a4cdcf7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cdcf7c",
  null
  
)

export default component.exports